import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUniversity } from "@fortawesome/pro-regular-svg-icons";

import { SelectCountry } from "./SelectCountry";

import { useCountriesQuery } from "@/app/app.apiCountry";
import { InputWithCornerHint } from "../atoms/InputWithCornerHint";

interface FormManualBankPaymentProps {
  handleChange: any;
  setFieldValue: any;
  values: any;
  errors: any;
  touched: any;
}

const FormManualBankPayment = ({
  setFieldValue,
  handleChange,
  values,
  errors,
  touched,
}: FormManualBankPaymentProps) => {
  const [t] = useTranslation();

  const countriesQuery = useCountriesQuery(undefined);

  //errors
  const [error, setErrors] = useState({
    email: false,
    name: false,
    address: false,
  });

  const countryOptions = useMemo(() => {
    return countriesQuery?.data?.map((country) => ({
      ...country,
      code: country.isoCode,
      name: country.name,
    }));
  }, [countriesQuery]);

  return (
    <div className="space-y-4">
      <div>
        <p>{t("direct_debit.views.terms_2")}</p>
      </div>

      <div>
        <InputWithCornerHint
          label="IBAN"
          id="iban"
          name="iban"
          type="text"
          onChange={handleChange}
          value={values.iban}
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm"
        />
        {errors.iban && touched.iban && (
          <div className="text-red-600 text-sm">{errors.iban}</div>
        )}
      </div>

      <div>
        <InputWithCornerHint
          id="name"
          label={t("direct_debit.views.modal_name")}
          name="name"
          type="text"
          onChange={handleChange}
          value={values.name}
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm"
        />
        {errors.name && touched.name && (
          <div className="text-red-600 text-sm">{errors.name}</div>
        )}
      </div>

      <div>
        <InputWithCornerHint
          label={t("direct_debit.views.modal_email")}
          onError={(error) => setErrors({ ...errors, email: error })}
          id="email"
          name="email"
          error={!!errors.email}
          type="email"
          onChange={handleChange}
          value={values.email}
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm"
        />
        {errors.email && touched.email && (
          <div className="text-red-600 text-sm">{errors.email}</div>
        )}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <InputWithCornerHint
            label={t("direct_debit.views.modal_address")}
            id="address"
            name="address"
            type="text"
            onChange={handleChange}
            value={values.address}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm"
          />
          {errors.address && touched.address && (
            <div className="text-red-600 text-sm">{errors.address}</div>
          )}
        </div>

        <div>
          <SelectCountry
            selected={countryOptions?.find(
              (country) => country.isoCode == values.countryCode
            )}
            setSelected={(selected) =>
              setFieldValue("countryCode", selected?.isoCode)
            }
            options={countryOptions}
            tittle={t("branch.views.country")}
          />
        </div>

        {/*
        <div>
          <label
            htmlFor="country"
            className="block text-sm font-medium text-gray-700"
          >
            {t("direct_debit.views.modal_country")}
          </label>

          <select
            id="country"
            name="country"
            onChange={handleChange}
            value={values.country}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm"
          >
            <option value="">{t("Select Country")}</option>
            <option value="country1">Country 1</option>
            <option value="country2">Country 2</option>
            <option value="country3">Country 3</option>
          </select>
          {errors.country && touched.country && (
            <div className="text-red-600 text-sm">{errors.country}</div>
          )}
        </div>
        */}
      </div>

      {values.statusUser && (
        <div className="col-12 mt-5">
          <p className="text-center">
            {t("El usuario con etiqueta")} {values.statusUser.name}{" "}
            {t("tiene un descuento del")} {values.statusUser.discount}%
          </p>
        </div>
      )}
    </div>
  );
};

export default FormManualBankPayment;
